<div style="display: flex; flex-direction: column; height: 100%;">
  <div class="procedure-selection" data-cy="procedure-selection-dialog-header">
    Select procedure / case for appointment
  </div>

  <mat-tab-group (selectedTabChange)="tabChanged($event)" data-cy="procedure-selection-tabs" style="flex: 1; overflow: hidden;">
    <mat-tab label="New Case" data-cy="procedure-selection-new-case-tab">
      <div style="display: flex; flex-direction: column; height: 100%; padding: 16px;">
        <div style="margin-bottom: 16px;">
          
          <div style="display: flex; justify-content: space-between; align-items: center; margin-left: 8px; margin-bottom: 8px;">
            <span style="font-size: medium; font-weight: bold;" data-cy="procedure-selection-new-case-title">Reason For This Appointment</span>
            <dx-button
              icon="edit"
              [width]="30"
              [height]="30"
              [stylingMode]="'text'"
              [type]="'default'"
              (onClick)="onEditReasonClick()"
              data-cy="edit-reason-button">
            </dx-button>
          </div>

          <dx-list #tdoListReasons 
            [dataSource]="appointmentReasonsList"
            [selectionMode]="'single'"
            height="600px"
            (onSelectionChanged)="onReasonSelectionChanged($event)"
            data-cy="procedure-selection-new-case-reasons-list"
          >
            <div *dxTemplate="let data of 'item'" data-cy="procedure-selection-new-case-reason-item" style="display: flex; flex-direction: row;">
              <div style=" border-radius: 25px; width: 20px; margin-right: 10px; text-align: center;" [style.backgroundColor]="getBackgroundColor(data.ColorSchemeID)" [style.color]="getForeColor(data.ColorSchemeID)">
                .
              </div>
              <div data-cy="procedure-selection-new-case-reason-name">{{ data.Description }}</div>
            </div>
          </dx-list>
        </div>
        
        <div style="flex: 1; display: flex; flex-direction: column;">
          <span style="font-size: medium; font-weight: bold; margin-left: 8px; margin-bottom: 8px;" data-cy="procedure-selection-new-case-title">
            Procedure for this appointment
          </span>
          <span style=" margin-left: 8px; margin-bottom: 8px;" data-cy="procedure-selection-new-case-title">
            {{selectExstProcedureName}}
          </span>
         

          <!-- <dx-list
            #procList
            [dataSource]="data.procedures"
            [selectionMode]="'none'"
            [pageLoadMode]="'scroll'"
            [keyExpr]="'CaseProcedureId'"
            [selectedItemKeys]="selectedProcItemKeys"
            height="200px"
            readOnly="true"
            style="flex: 1;"
            (onSelectionChanged)="onProcSelectionChanged($event)"
            data-cy="procedure-selection-new-procedures-list"
          >
            <div *dxTemplate="let d of 'item'" data-cy="procedure-selection-procedure-item">
              <div data-cy="procedure-selection-procedure-name">{{ d.ProcedureName }}</div>
            </div>
          </dx-list> -->
        </div>
      </div>
    </mat-tab>
    
    <mat-tab label="Existing Case" data-cy="procedure-selection-existing-case-tab">
      <div style="display: flex; flex-direction: column; height: 100%; padding: 16px;">
        <div style="margin-bottom: 16px;">
          <span style="font-size: medium; font-weight: bold; margin-left: 8px; margin-bottom: 8px;" data-cy="procedure-selection-existing-case-title">Step 1 - Select a Case</span>

          <dx-list
            #caseList
            [dataSource]="patientCases"
            style="height: 300px;"
            [selectionMode]="'single'"
            [pageLoadMode]="'scroll'"
            (onSelectionChanged)="onCaseSelectionChanged($event)"
            data-cy="procedure-selection-existing-cases-list"
          >
            <div *dxTemplate="let data of 'item'" class="caserow" data-cy="procedure-selection-case-item">
              <div class="casecolumn-descr" data-cy="procedure-selection-case-description">{{ data.Description == null || data.Description =='' ? '-' : data.Description }}</div>
              <div class="casecolumn-tooth" data-cy="procedure-selection-case-tooth">{{ data.Teeth=='' ? '-' : data.Teeth }}</div>
              <div class="casecolumn-status" data-cy="procedure-selection-case-status">{{ data.CaseStatus }}</div>
              <div class="casecolumn-status-date" data-cy="procedure-selection-case-date">{{ data.StatusOn | date: 'shortDate' }} {{ data.StatusOn | date: 'shortTime' }}</div>
            </div>
          </dx-list>
        </div>

        <div style="flex: 1; display: flex; flex-direction: column;">
          <span style="font-size: medium; font-weight: bold; margin-left: 8px; margin-bottom: 8px;" data-cy="procedure-selection-case-procedures-title">Step 2 - Select a Procedure from the case</span>

          <dx-list
            #caseProcList
            [dataSource]="patientCaseProcedures"
            style="flex: 1;"
            [selectionMode]="'single'"
            (onSelectionChanged)="onCaseProcSelectionChanged($event)"
            data-cy="procedure-selection-case-procedures-list"
          >
            <div *dxTemplate="let data of 'item'" data-cy="procedure-selection-case-procedure-item">
              <div data-cy="procedure-selection-case-procedure-name">{{ data.ProcedureName }}</div>
            </div>
          </dx-list>

          <div data-cy="procedure-selection-followup-container" style="margin-top: 16px;">
            <div style="margin-bottom: 8px;">Reason for followup</div>
            <app-tdo-enum-select style="z-index: 1000;" [validValueItemId]="selectEnumCaseFollowupReasonID" name="enumCaseFollowupReason"
                                 (enumSelected)="onDropdownItemSelected($event)" data-cy="procedure-selection-followup-reason"></app-tdo-enum-select>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="section-footer" style="flex-basis: 46px; padding-top: 6px; flex-shrink: 0;" data-cy="procedure-selection-footer">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="procedure-selection-cancel-button">Cancel</button>
    <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="procedure-selection-ok-button">Ok</button>
  </div>
</div>